import { hasValue } from '@curby/shared';
import { Role, RoleName } from '../../../../backend/src/types.generated';

type PossibleRoutes = 'council' | 'facility' | 'user';
type RouteOptions = PossibleRoutes | 'picker' | 'no-access';

const roleRouteMap: Partial<Record<RoleName, PossibleRoutes>> = {
	COUNCIL: 'council',
	FACILITY: 'facility',
	USER: 'user',
};

export const calculateRouteOptions = (roles: Role[]) => {
	const possibleRoutes = roles.map((role) => roleRouteMap[role?.name]).filter(hasValue) ?? [];

	const routingType: RouteOptions =
		possibleRoutes.length === 1
			? possibleRoutes[0]
			: possibleRoutes.length > 1
				? 'picker'
				: 'no-access';

	return { possibleRoutes, routingType };
};
